import { pluralize } from "@sellar-io/common";
import { Icon } from "@sellar-io/components";
import { AlertCompact } from "../../../components/alert/AlertCompact";

export const CustomersToConvertAlert = ({
  numberOfCustomers,
  onClick,
  active,
}: {
  numberOfCustomers: number;
  onClick: () => void;
  active: boolean;
}) => {
  return (
    <AlertCompact
      type="information"
      className="w-full font-semibold"
      onClick={onClick}
    >
      <div className="flex w-full items-center justify-between">
        {active ? (
          <span className="font-normal">
            Showing{" "}
            <span className="font-semibold">
              {numberOfCustomers} {pluralize("customer", numberOfCustomers)}
            </span>{" "}
            with custom discounts to migrate
          </span>
        ) : (
          <span>
            You have {numberOfCustomers}{" "}
            {pluralize("customer", numberOfCustomers)} with custom discounts to
            migrate
          </span>
        )}
        <span className="flex items-center gap-2 font-bold text-indigo-800 md:ml-2">
          {active ? "Show all customers" : "View customers"}
          <Icon icon="CHEVRON_RIGHT" />
        </span>
      </div>
    </AlertCompact>
  );
};
